/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { VENCIMENTO_URGENCY } from './constants';

const KPI_CONFIG = [
  {
    key: VENCIMENTO_URGENCY.OVERDUE,
    label: 'Vencidas',
    colorKey: 'error',
    summaryKey: 'vencidas',
  },
  {
    key: VENCIMENTO_URGENCY.TODAY,
    label: 'Hoje',
    colorKey: 'warning.dark',
    summaryKey: 'vencemHoje',
  },
  {
    key: VENCIMENTO_URGENCY.WEEK,
    label: '7 dias',
    colorKey: 'warning',
    summaryKey: 'vencemEm7Dias',
  },
  {
    key: VENCIMENTO_URGENCY.MONTH,
    label: '30 dias',
    colorKey: 'info',
    summaryKey: 'vencemEm30Dias',
  },
];

const resolveColor = (theme, colorKey) => {
  if (colorKey === 'warning.dark') {
    return theme.palette.warning.dark;
  }
  if (theme.palette[colorKey]) {
    return theme.palette[colorKey].main;
  }
  return theme.palette.text.secondary;
};

const formatNumber = (n) => (n ?? 0).toLocaleString('pt-BR');

const UrgencyKpiCell = ({ config, value, active, onClick }) => (
  <ButtonBase
    onClick={onClick}
    focusRipple
    sx={{
      flex: 1,
      minWidth: 72,
      justifyContent: 'flex-start',
      textAlign: 'left',
      px: 1,
      py: 0.75,
      borderRadius: 1,
      transition: 'background-color 0.2s ease',
      backgroundColor: (theme) =>
        active ? `${resolveColor(theme, config.colorKey)}14` : 'transparent',
      border: (theme) =>
        active
          ? `1px solid ${resolveColor(theme, config.colorKey)}`
          : '1px solid transparent',
      '&:hover': {
        backgroundColor: (theme) => `${resolveColor(theme, config.colorKey)}0F`,
      },
    }}
  >
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          lineHeight: 1.2,
          color: (theme) => resolveColor(theme, config.colorKey),
          display: 'block',
        }}
        noWrap
      >
        {config.label}
      </Typography>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
        {formatNumber(value)}
      </Typography>
    </Box>
  </ButtonBase>
);

UrgencyKpiCell.propTypes = {
  config: PropTypes.object.isRequired,
  value: PropTypes.number.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

UrgencyKpiCell.defaultProps = {
  active: false,
};

const VencimentoUrgencyKpis = ({ summary, activeUrgency, onUrgencyChange }) => {
  const s = {
    vencidas: summary?.vencidas ?? 0,
    vencemHoje: summary?.vencemHoje ?? 0,
    vencemEm7Dias: summary?.vencemEm7Dias ?? 0,
    vencemEm30Dias: summary?.vencemEm30Dias ?? 0,
  };

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ mb: 0.5 }}>
      {KPI_CONFIG.map((config) => (
        <UrgencyKpiCell
          key={config.key}
          config={config}
          value={s[config.summaryKey]}
          active={activeUrgency === config.key}
          onClick={() => {
            onUrgencyChange?.(activeUrgency === config.key ? null : config.key);
          }}
        />
      ))}
    </Stack>
  );
};

VencimentoUrgencyKpis.propTypes = {
  summary: PropTypes.object,
  activeUrgency: PropTypes.string,
  onUrgencyChange: PropTypes.func,
};

VencimentoUrgencyKpis.defaultProps = {
  summary: null,
  activeUrgency: null,
  onUrgencyChange: null,
};

export default VencimentoUrgencyKpis;
